import { ReactElement, useEffect } from 'react'
import { Rifm } from 'rifm'
import { FONT_FAMILY } from 'src/shared/constants/styling-constants'
import styled from 'styled-components'

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  error?: boolean
  maxLength?: number
  uppercase?: boolean
}

const InputStyled = styled.input<{ $error: boolean }>`
  width: 100%;
  text-align: left; /* Text usually aligns left */
  outline: none;
  border: none;
  padding: 0 10px;
  font-family: ${FONT_FAMILY};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
  letter-spacing: ${({ theme }) => theme.typography.body2.letterSpacing};
  background-color: ${({ $error, theme }) => ($error ? theme.colors.error.light : 'inherit')};
  color: ${({ $error, theme }) => ($error ? theme.colors.error.dark : 'inherit')};
  font-weight: ${({ $error, theme }) => ($error ? theme.typography.subtitle2.fontWeight : 'inherit')};
`

export const TextInput = ({
  value,
  onChange,
  error = false,
  maxLength,
  uppercase = false,
  placeholder,
}: Props): ReactElement => {
  // Regex to accept all characters
  const acceptRegex = /./g

  const formatText = (string: string) => {
    let formatted = string

    if (uppercase) {
      formatted = formatted.toUpperCase()
    }

    if (maxLength && formatted.length > maxLength) {
      formatted = formatted.slice(0, maxLength)
    }

    return formatted
  }

  useEffect(() => {
    // Ensure initial formatting is applied
    const formatted = formatText(value)
    if (formatted !== value) {
      onChange(formatted)
    }
  }, [value])

  return (
    <Rifm accept={acceptRegex} format={formatText} value={value} onChange={onChange}>
      {({ value, onChange }) => (
        <InputStyled type="text" autoFocus placeholder={placeholder} value={value} onChange={onChange} $error={error} />
      )}
    </Rifm>
  )
}
